
// SVG Icon: location2
export default { id: "terriajs-location2" };
export const id = "terriajs-location2";
export const name = "location2";
